import { render, staticRenderFns } from "./CompletedSurveysTab.vue?vue&type=template&id=77bd28fe&scoped=true&"
import script from "./CompletedSurveysTab.vue?vue&type=script&lang=js&"
export * from "./CompletedSurveysTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bd28fe",
  null
  
)

export default component.exports